import React from "react";
import styles from "./NavigationBar.module.css";
import { NavBtn } from "../Buttons/NavBtn/NavBtn";
import { SocialIcons } from "../Icons/Icons";
import {
  BsInstagram,
  BsFacebook,
  BsPinterest,
  BsMailbox,
} from "react-icons/bs";
import logo from "../assets/logo/logo.svg";

function NavigationBar({
  inicio,
  gallery,
  galleryAmigurumis,
  galleryAnime,
  galleryChenille,
  galleryKeychain,
  galleryRandom,
  aboutMe,
  contact,
  faq,
}) {
  return (
    <div className={styles.bar}>
      <NavBtn
        style={{ gridColumn: "2/4" }}
        logo={logo}
        inicio={inicio}
        gallery={gallery}
        galleryAmigurumis={galleryAmigurumis}
        galleryAnime={galleryAnime}
        galleryChenille={galleryChenille}
        galleryKeychain={galleryKeychain}
        galleryRandom={galleryRandom}
        aboutMe={aboutMe}
        contact={contact}
        faq={faq}
      ></NavBtn>
      <div className={styles.social}>
        <SocialIcons
          href="https://www.instagram.com/pawpawneedle/"
          icon={<BsInstagram></BsInstagram>}
        ></SocialIcons>
        <SocialIcons
          href="https://www.facebook.com/pawpawneedle"
          icon={<BsFacebook></BsFacebook>}
        ></SocialIcons>
        <SocialIcons
          href="mailto:pawpawneedle@gmail.com"
          icon={<BsMailbox></BsMailbox>}
        ></SocialIcons>
        <SocialIcons
          href="https://pin.it/2aEu7Se"
          icon={<BsPinterest></BsPinterest>}
        ></SocialIcons>
      </div>
    </div>
  );
}

export { NavigationBar };
